<template>
  <div v-if="access">
    <p class="modal-text">
      {{ $t("admin.adminWhitelistDelete.text", { value: access.value }) }}
    </p>
    <button v-bind:disabled="loading" @click="deleteWhitelist" class="button">
      {{ $t("admin.adminWhitelistDelete.button.delete") }}
    </button>
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";

import { adminService } from "@/services/admin.service";

export default {
  props: {
    planId: {
      type: Number,
      required: true,
    },
    currentAccess: {
      type: Object,
      required: true,
    },
    fetchData: {
      type: Function,
      required: true,
    },
  },
  name: "AdminWhitelistDelete",
  components: {
    Modal,
  },
  data: function () {
    return {
      access: null,
      loading: false,
    };
  },
  mounted() {
    this.access = this.currentAccess;
  },
  methods: {
    deleteWhitelist: function () {
      this.loading = true;
      adminService.whitelistDelete(this.planId, this.access.id).then(() => {
        this.fetchData();
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped lang="scss">
button {
  margin: 17px 0 40px 0;
  line-height: 54px;
  background-color: $secondary-dark;
  color: $text-light;
}
</style>
